/* ============================================================
   Favoris (wishlist) — Illulart — rev. 2 (ratio vignettes = collection)
   - Client CONNECTÉ : favoris stockés sur le compte (metafield),
     via l'App Proxy /apps/wallpaper/wishlist (POST toggle/merge).
   - INVITÉ : favoris en localStorage, fusionnés dans le compte
     à la connexion (POST merge).
   Dégrade proprement vers localStorage si le proxy ne répond pas.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'illu_wishlist_v1';
  var cfg = window.IlluWishlistConfig || {};
  var ENDPOINT = cfg.endpoint || '/apps/wallpaper/wishlist';
  var loggedIn = !!cfg.loggedIn;

  /* --- localStorage (invités) --- */
  function lsRead() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function lsWrite(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function lsClear() { try { localStorage.removeItem(KEY); } catch (e) {} }

  /* --- Modale d'invitation à la connexion (invités) --- */
  var DISMISS_KEY = 'illu_wishlist_guest_dismissed';
  function guestDismissed() { try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; } }
  function setGuestDismissed() { try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {} }
  function openLoginModal() {
    var m = document.getElementById('wl-login-modal');
    if (!m) return;
    m.hidden = false; m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wl-modal-open');
  }
  function closeLoginModal() {
    var m = document.getElementById('wl-login-modal');
    if (!m) return;
    m.hidden = true; m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wl-modal-open');
  }
  function wireLoginModal() {
    var m = document.getElementById('wl-login-modal');
    if (!m) return;
    m.querySelectorAll('[data-wl-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () { setGuestDismissed(); closeLoginModal(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !m.hidden) { setGuestDismissed(); closeLoginModal(); }
    });
    var login = document.getElementById('wl-modal-login');
    if (login) login.addEventListener('click', function () {
      var b = login.getAttribute('href');
      var sep = b.indexOf('?') === -1 ? '?' : '&';
      login.setAttribute('href', b + sep + 'return_url=' + encodeURIComponent(location.pathname + location.search));
    });
  }

  /* --- État mémoire = source de vérité pour l'UI --- */
  var current = loggedIn
    ? new Set((cfg.ids || []).map(String))
    : new Set(lsRead().map(function (i) { return String(i.id); }));

  function has(id) { return current.has(String(id)); }
  function count() { return current.size; }

  window.IlluWishlist = {
    has: has, count: count, loggedIn: loggedIn,
    ids: function () { return Array.from(current); }
  };

  function emitChange() {
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: count() } }));
  }

  /* --- Synchronisation visuelle --- */
  function syncButton(btn) {
    var active = has(btn.getAttribute('data-wishlist-id'));
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var lbl = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    btn.setAttribute('aria-label', lbl);
    btn.setAttribute('title', lbl);
  }
  function syncAll(root) {
    (root || document).querySelectorAll('.wishlist-btn[data-wishlist-id]').forEach(syncButton);
  }
  function updateBadges() {
    var c = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = c;
      el.classList.toggle('is-empty', c === 0);
    });
  }

  /* --- Appel App Proxy (POST) --- */
  function remote(action, payload) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ action: action }, payload || {}))
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* --- Toggle d'un favori --- */
  function toggle(item) {
    var id = String(item.id);
    var willAdd = !current.has(id);
    // mise à jour optimiste (UI réactive immédiatement)
    if (willAdd) current.add(id); else current.delete(id);
    syncAll(); updateBadges();

    if (loggedIn) {
      remote('toggle', { id: id }).then(function (res) {
        if (res && Array.isArray(res.ids)) {
          current = new Set(res.ids.map(String));      // source = serveur
        } else if (!res) {
          if (willAdd) current.delete(id); else current.add(id); // échec → revert
        }
        syncAll(); updateBadges(); reconcileFavoritesPage(); emitChange();
      });
    } else {
      var list = lsRead();
      if (willAdd) {
        if (!list.some(function (i) { return String(i.id) === id; })) list.push({ id: id, handle: item.handle });
      } else {
        list = list.filter(function (i) { return String(i.id) !== id; });
      }
      lsWrite(list);
      reconcileFavoritesPage(); emitChange();
      if (willAdd && !guestDismissed()) openLoginModal();
    }
    return willAdd;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({ id: btn.getAttribute('data-wishlist-id'), handle: btn.getAttribute('data-wishlist-handle') });
    btn.classList.add('wishlist-btn--pop');
    setTimeout(function () { btn.classList.remove('wishlist-btn--pop'); }, 300);
  }, false);

  document.addEventListener('wishlist:change', updateBadges);
  document.addEventListener('shopify:section:load', function () { syncAll(); });

  /* --- Fusion des favoris invité dans le compte à la connexion --- */
  function mergeGuestIntoAccount() {
    if (!loggedIn) return;
    var guest = lsRead();
    if (!guest.length) return;
    remote('merge', { ids: guest.map(function (i) { return String(i.id); }) }).then(function (res) {
      if (res && Array.isArray(res.ids)) {
        current = new Set(res.ids.map(String));
        lsClear();
        syncAll(); updateBadges(); emitChange();
        // si on est sur la page favoris (rendue serveur), recharger pour afficher les nouveaux
        if (document.getElementById('wishlist-page')) location.reload();
      }
    });
  }

  /* --- Dégradé du cœur 3D (défini une fois) --- */
  function injectDefs() {
    if (document.getElementById('wl-svg-defs')) return;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.id = 'wl-svg-defs';
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    svg.innerHTML =
      '<defs><linearGradient id="wl-heart-grad" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#ff8da6"/>' +
        '<stop offset="0.55" stop-color="#e85d77"/>' +
        '<stop offset="1" stop-color="#c33f5b"/>' +
      '</linearGradient></defs>';
    document.body.appendChild(svg);
  }

  /* --- Page « Mes favoris » --- */
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function withWidth(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function guestCardHTML(p) {
    var img = withWidth(p.featured_image || (p.images && p.images[0]) || '', 540);
    var imgTag = img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
    var price = (p.price_varies && p.price_min != null) ? ('À partir de ' + money(p.price_min)) : money(p.price);
    return '' +
      '<div class="grid__item grid-product small--one-half medium-up--one-quarter wishlist-card" data-product-handle="' + p.handle + '" data-product-id="' + p.id + '">' +
        '<div class="grid-product__content">' +
          '<button type="button" class="wishlist-btn wishlist-btn--floating is-active" data-wishlist-toggle data-wishlist-id="' + p.id + '" data-wishlist-handle="' + p.handle + '" aria-pressed="true" aria-label="Retirer des favoris" title="Retirer des favoris">' +
            '<svg class="wishlist-btn__icon" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path class="wl-heart" d="M12 20.7l-1.45-1.32C5.4 14.74 2 11.66 2 7.92 2 4.84 4.42 2.4 7.5 2.4c1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.44 5.5 5.52 0 3.74-3.4 6.82-8.55 11.47L12 20.7z"/><ellipse class="wl-heart-shine" cx="8" cy="7.6" rx="2.3" ry="1.4" transform="rotate(-35 8 7.6)"/></svg>' +
          '</button>' +
          '<a href="' + p.url + '" class="grid-product__link">' +
            '<div class="grid-product__image-mask"><div class="grid__image-ratio grid__image-ratio--landscape">' + imgTag + '</div></div>' +
            '<div class="grid-product__meta">' +
              '<div class="grid-product__title">' + escapeHtml(p.title) + '</div>' +
              '<div class="grid-product__price">' + price + '</div>' +
            '</div>' +
          '</a>' +
        '</div>' +
      '</div>';
  }

  var guestRendering = false;
  function renderFavoritesGuest(grid, empty) {
    if (guestRendering) return;
    var list = lsRead();
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    guestRendering = true;
    grid.innerHTML = '<p class="wishlist-loading">Chargement de vos favoris…</p>';
    Promise.all(list.map(function (it) {
      return fetch('/products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      products.forEach(function (p) { if (p) grid.insertAdjacentHTML('beforeend', guestCardHTML(p)); });
      if (!grid.children.length && empty) empty.hidden = false;
      syncAll(grid);
      guestRendering = false;
    });
  }

  function reconcileFavoritesPage() {
    var wrap = document.getElementById('wishlist-page');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-wishlist-grid]');
    var empty = wrap.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    if (grid.getAttribute('data-wishlist-rendered') === 'server') {
      // Connecté : retirer les cartes qui ne sont plus en favori
      grid.querySelectorAll('[data-product-id]').forEach(function (card) {
        if (!current.has(String(card.getAttribute('data-product-id')))) card.remove();
      });
      if (empty) empty.hidden = grid.children.length > 0;
    } else {
      renderFavoritesGuest(grid, empty);
    }
  }

  function init() {
    injectDefs();
    wireLoginModal();
    syncAll();
    updateBadges();
    mergeGuestIntoAccount();
    reconcileFavoritesPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
